import type { CSSProperties } from 'react';
import { twMerge } from 'tailwind-merge';
import { ORDER_PRODUCT_STATUS_COLORS } from '@witmetrics/unison-core';
import { classes, styles } from './utils';

export type OrderProductStatusCircleProps = {
  className?: string;
  style?: CSSProperties;
  size?: number;
  orderProductStatusId: keyof typeof ORDER_PRODUCT_STATUS_COLORS;
};

export default function OrderProductStatusCircle({
  className,
  style = {},
  size = 16,
  orderProductStatusId,
}: OrderProductStatusCircleProps) {
  return (
    <div
      style={{ ...styles.wrapper(size), ...style }}
      className={twMerge(
        classes.wrapper,
        ORDER_PRODUCT_STATUS_COLORS[orderProductStatusId].bg,
        className
      )}
    />
  );
}
